import React from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import logo from "../logo-height.webp";
import { useAuth } from "../contexts/AuthContext";

const Layout = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await logout();
            navigate("/login");
        } catch (err) {
            console.error("Failed to log out:", err);
        }
    };

    return (
        <div className="min-h-screen bg-[#E4F1FF] text-[#333333]">
            <nav className="bg-[#333333] text-[#E4F1FF] px-6 flex justify-between items-center shadow h-[auto]">
                <h1 className="text-xl font-bold">
                    <img src={logo} alt="Your Logo" className="w-32 block" />
                </h1>
                <div className="space-x-6 font-medium">
                    <Link to="/">Home</Link>
                    {!user ? (
                        <>
                            <Link to="/login">Login</Link>
                            <Link to="/register">Register</Link>
                        </>
                    ) : (
                        <>
                            <Link to="/dashboard">My Dashboard</Link>
                            <button
                                onClick={handleLogout}
                                className="text-[#E4F1FF] hover:underline"
                            >
                                Logout
                            </button>
                        </>
                    )}
                </div>
            </nav>

            <main className="p-6">
                <Outlet />
            </main>
        </div>
    );
};

export default Layout;
